<template>
        <div class="page-content conmon-top tabs-class">
        <el-tabs class="setting-tabs" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="注册设置" name="first">
                <div>
                    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
                        <el-row class="search-title" style="background-color: #fafafa">
                            <el-col :span="4" class="search-nav-left">
                                <i class="el-icon-search" style="color: #4882ff;font-size: 18px;font-weight: bold;"></i>
                                <span class="order-list-search-span">筛选查询</span>
                            </el-col>
                            <el-col :span="20" class="search-nav-right">
                                <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide"> {{ hide? '收起查询':'展开查询' }}</el-button>
                                <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">{{ hide? '收起查询':'展开查询' }}</el-button>
                                <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
                                <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i"  @click="hide=!hide"></i>
                                <el-button class="search-btn-new" type="primary" size="small" @click="searchData">查询</el-button>
                            </el-col>
                        </el-row>
                        <el-collapse-transition>
                            <div v-show="hide" class="search-content common-search-formtype">
                                <el-form :inline="true" :model="searchTmp" class="search-content-item">
                                    <el-form-item label="类型:">
                                        <el-select v-model="searchTmp.type" placeholder="请选择">
                                            <el-option
                                                    v-for="item in typeOptions"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </el-collapse-transition>
                    </div>
                    <el-row class="search-title common-table-top" style="padding-right:0">
                        <el-col :span="4" style="text-align: left;">
                            <i class="el-icon-document" style="color: #4882ff;font-size: 18px;font-weight: bold;margin-left: 32px"></i>
                            <span class="order-list-search-span">活动列表</span>
                        </el-col>
                        <el-col :span="20" class="text-align-right">
                            <el-button type="primary" class="add-btn" style="float: right;" @click="addRegisterAction">添加</el-button>
                        </el-col>
                    </el-row>
                    <el-row class="import-data-title table-first-style">
                        <el-table
                                :data="tableData"
                                v-loading="loading"
                                class="table">
                            <el-table-column
                                    prop="title"
                                    label="活动名称">
                            </el-table-column>
                          <el-table-column
                            prop="gift"
                            label="奖品名称">
                          </el-table-column>
                            <el-table-column
                                    prop="type"
                                    label="类型">
                            </el-table-column>

                            <!--<el-table-column-->
                                    <!--prop="pro_code"-->
                                    <!--label="奖品说明">-->
                            <!--</el-table-column>-->
                            <el-table-column
                                    label="开始时间"
                                    width="135">
                                <template slot-scope="scope">
                                    {{scope.row.start | formatDate}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="结束时间"
                                    width="135">
                                <template slot-scope="scope">
                                    {{scope.row.end | formatDate}}
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="120" style="display: flex;justify-content: center">
                                <template slot-scope="scope">
                                    <div class="op-link editColor" @click="editRegisterAction(scope.row.id)">编辑</div>
                                    <div class="op-link deleteColor" @click="deleteRegisterAction(scope.row.id)">删除</div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="table-foot">
                            <el-pagination
                                    class="table-foot-pagination"
                                    background
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :page-size="limit"
                                    layout="total, prev, pager, next, jumper"
                                    :total="totalCount">
                            </el-pagination>
                        </div>
                    </el-row>
                </div>
            </el-tab-pane>
            <el-tab-pane label="注册订单" name="second">
                <div>
                    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
                        <el-row class="search-title" style="background-color: #fafafa">
                            <el-col :span="4" class="search-nav-left">
                                <i class="el-icon-search" style="color: #4882ff;font-size: 18px;font-weight: bold;"></i>
                                <span class="order-list-search-span">筛选查询</span>
                            </el-col>
                            <el-col :span="20" class="search-nav-right">
                                <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide"> {{ hide? '收起查询':'展开查询' }}</el-button>
                                <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">{{ hide? '收起查询':'展开查询' }}</el-button>
                                <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
                                <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
                                <el-button class="search-btn-new" type="primary" size="small" @click="searchOrderData">查询</el-button>
                            </el-col>
                        </el-row>
                        <el-collapse-transition>
                            <div v-show="hide" class="search-content common-search-formtype">
                                <el-form :inline="true" :model="formInlineTmp" class="search-content-item">
                                    <el-form-item label="状态:">
                                        <el-select v-model="formInlineTmp.shipping_status" placeholder="请选择">
                                            <el-option
                                                    v-for="item in statusOptions"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="类型:">
                                        <el-select v-model="formInlineTmp.gift_type" placeholder="请选择">
                                            <el-option
                                                    v-for="item in gifttypeOptions"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </el-collapse-transition>
                    </div>
                    <el-row class="search-title common-table-top" style="padding-right:0">
                        <el-col :span="4" style="text-align: left;">
                            <i class="el-icon-document" style="color: #4882ff;font-size: 18px;font-weight: bold;margin-right: 6px"></i>
                            <span class="order-list-search-span">数据列表</span>
                        </el-col>
                        <el-col :span="20" class="text-align-right">
                            <el-button type="primary" class="add-btn" style="float: right;" @click="sendSync">发货同步</el-button>
                            <el-button type="primary" class="add-btn" style="float: right;margin-right:16px" @click="orderSync">订单同步 </el-button>
                            <el-button type="primary" class="add-btn" style="float:right;margin-right:16px" @click="exporeAction">Excel导出</el-button>
                        </el-col>
                    </el-row>
                    <el-row class="import-data-title table-first-style">
                        <el-table
                            :data="orderData"
                            v-loading="loadData"
                            class="table">
                        <el-table-column
                                prop="order_num"
                                label="订单编号"
                                width="155">
                        </el-table-column>
                        <el-table-column
                                width="180"
                                prop="vip_card"
                                label="会员编号">
                        </el-table-column>
                        <el-table-column
                                width="80"
                                prop="consignee_name"
                                label="姓名">
                        </el-table-column>
                        <el-table-column
                                width="110"
                                prop="consignee_number"
                                label="手机号">
                        </el-table-column>
                        <el-table-column
                                prop=""
                                label="收货地址">
                            <template slot-scope="scope">
                              <el-tooltip class="item" style="cursor: pointer;" effect="dark" :content="scope.row.consignee_address" placement="bottom">
                                <span>{{ scope.row.consignee_province }}- {{ scope.row.consignee_city }}-{{ scope.row.consignee_county }}</span>
                              </el-tooltip>
                                <!-- <span>{{ scope.row.consignee_province }}- {{ scope.row.consignee_city }}-{{ scope.row.consignee_county }}</span> -->
                            </template>
                        </el-table-column>
                        <el-table-column
                                width="80"
                                label="类型">
                            <template slot-scope="scope">
                                <div v-if="scope.row.gift_type === 1">积分</div>
                                <div v-if="scope.row.gift_type === 2">实物</div>
                                <div v-if="scope.row.gift_type === 3">优惠券</div>
                                <div v-if="scope.row.gift_type === 4">游戏</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="gift"
                                label="奖品名称">
                        </el-table-column>
                        <el-table-column
                                prop="create_time"
                                width="135"
                                label="创建时间">
                            <template slot-scope="scope">
                                  {{scope.row.create_time | formatDate}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                width="90"
                                label="发货状态">
                            <template slot-scope="scope">
                                <div v-if="scope.row.shipping_status === -1">发货失败</div>
                                <div v-if="scope.row.shipping_status === 0">未发货</div>
                                <div v-if="scope.row.shipping_status === 1">发货中</div>
                                <div v-if="scope.row.shipping_status === 2">已发货</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="mail_no"
                                width="110"
                                label="快递单号">
                        </el-table-column>
                    </el-table>
                        <div class="table-foot">
                            <el-pagination
                                    class="table-foot-pagination"
                                    background
                                    @size-change="handleSizeChange2"
                                    @current-change="handleCurrentChange2"
                                    :page-size="limit"
                                    layout="total, prev, pager, next, jumper"
                                    :total="totalCount2">
                            </el-pagination>
                        </div>
                    </el-row>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import { getRegisterList, deleteRegister, getRegisterOrderList, sendSyncData, orderSyncData, exportRegisterOrder } from '@/api/customer.js'
export default {
  name: 'registerPolite',
  data () {
    return {
      searchTmp: {},
      loading: true,
      loadData: true,
      hide: true,
      tableData: [],
      orderData: [],
      activeName: 'first',
      id: this.$route.query.id,
      search: {
        gift_type: '',
        shipping_status: ''
      },
      formInlineTmp: {},
      formInline: {
        shipping_status: '',
        gift_type: ''
      },
      typeOptions: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '积分'
        },
        {
          value: '2',
          label: '实物'
        },
        {
          value: '3',
          label: '优惠券'
        },
        {
          value: '4',
          label: '游戏'
        }
      ],
      gifttypeOptions: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '积分'
        },
        {
          value: '2',
          label: '实物'
        },
        {
          value: '3',
          label: '优惠券'
        }
      ],
      statusOptions: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '-1',
          label: '发货失败'
        },
        {
          value: '0',
          label: '未发货'
        },
        {
          value: '1',
          label: '发货中'
        },
        {
          value: '2',
          label: '已发货'
        }
      ],
      page: 1,
      orderPage: 1,
      limit: 10,
      totalCount: 0,
      totalCount2: 0,
      isSwitchClick: 1,
      memberLevelList: []
    }
  },
  methods: {
    searchData() {
      this.search = JSON.parse(JSON.stringify(this.searchTmp))
      this.page = 1
      this.getData()
    },
    searchOrderData() {
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.orderPage = 1
      this.getOrderData()
    },
    handleClick(tab, event) {
      this.getData()
      this.getOrderData()
    },
    // 添加
    addRegisterAction() {
      router.push('/home/add-register-polite')
    },
    // 编辑
    editRegisterAction(Id) {
      router.push({ path: '/home/edit-register-polite', query: { id: Id } })
    },
    // 删除
    deleteRegisterAction(id) {
      this.$confirm('确认删除该活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteRegister(id).then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', '删除活动成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
          this.getData()
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 设置列表分页
    handleSizeChange(val) {
      this.limit = val
      this.getData()
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    // 订单列表分页
    handleSizeChange2(val) {
      this.limit = val
      this.getOrderData()
    },
    handleCurrentChange2(page) {
      this.orderPage = page
      this.getOrderData()
    },
    // 订单excel导出
    exporeAction() {
      exportRegisterOrder(this.formInline).then(res => {
        this.download(res)
      })
    },
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      console.log(month)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    // 获取设置列表数据
    getData() {
      this.loading = true
      getRegisterList(this.page, this.search).then(res => {
        if (res.data.code === 0) {
          this.tableData = res.data.data.list
          this.totalCount = res.data.data.total
        } else {
          _g.toastMsg('error', res.data.error)
        }
        this.openLoading()
      })
    },
    // 获取订单列表数据
    getOrderData() {
      this.loadData = true
      getRegisterOrderList(this.orderPage, this.formInline).then(res => {
        if (res.data.code === 0) {
          this.orderData = res.data.data.list
          this.totalCount2 = res.data.data.total
        } else {
          _g.toastMsg('error', res.data.error)
        }
        this.loads()
      })
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    loads() {
      setTimeout(() => {
        this.loadData = false
      }, 500)
    },
    // 发货同步
    sendSync() {
      sendSyncData().then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '同步成功')
          this.getOrderData()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 订单同步
    orderSync() {
      orderSyncData().then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '同步成功')
          this.getOrderData()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    }
  },
  mounted() {
    this.getData()
    this.getOrderData()
  },
  components: {
  }
}
</script>
<style scoped>
</style>
